import React from "react";

const LightStatue = () => {
  return <div>LightStatue</div>;
};

export default LightStatue;
